import {
  APP_PART_TYPES,
  KEY_MENU,
  DEFAULT_WIDTH_COL,
  WARNING_DELETE_MESSAGE,
  EMPLOYEE_INFO_CHILDREN_SELECTION,
} from "@lhd/features/Apps/AppForm/constants";
import {
  Select,
  Checkbox,
  Input,
  Tooltip,
  Popconfirm,
  notification,
} from "antd";
import { Styles } from "./styles";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import InputEdit from "./components/InputEdit";
import {
  DUPLICATE_VALUES,
  EXCEPT_DEFAULT_VALUES,
  EXCEPT_HIDE_NAMES,
  EXCEPT_REQUIRED_FIELDS,
  EXCEPT_SHOW_COLUMNS,
  HIDDENS_COLUMNS_SHEET,
} from "@lhd/features/Apps/constants";
import { debounce } from "lodash";
import { useParams } from "react-router-dom";
import useReside from "./hooks/useReside";
import useDrag from "./hooks/useDrag";
import Button from "@lhd/components/Button";
import {
  BUTTON_HEIGHT,
  CopyTypeAppStore,
  FONT_SIZE,
  FONT_SIZE_VALUE,
} from "@lhd/constants";
import { Fragment, useMemo } from "react";
import { useSelector } from "react-redux";
import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";
import { DISPLAY_SIZES } from "@lhd/types";
import ButtonCommon from "@lhd/components/ButtonCommon";

interface IProps {
  isFirstRow?: boolean;
  width?: number;
  appPart?: AppPartType;
  index: number;
  optionsType?: {
    value: typeof APP_PART_TYPES[keyof typeof APP_PART_TYPES];
    label: string;
  }[];
  appCopyType?: keyof typeof CopyTypeAppStore;
  handleChangeAppById?: (
    appId: string,
    type: any,
    value: any,
    isEdit?: boolean,
  ) => void;
  handleMenuClick?: (appPart: any, type: any) => void;
  dataExistList?: string[];
  isAllowUpdateApp?: boolean;
  setEditingAppPart?: React.Dispatch<
    React.SetStateAction<AppPartType | undefined>
  >;
  handleUpdateWidth?: (newWidth: number, appPart?: AppPartType) => void;
  onDragging?: (index: number, x: number) => number | undefined;
  onDragStopped: (activeIndex: number, overIndex: number) => void;
}
const Item = (props: IProps) => {
  const {
    appPart,
    optionsType,
    isFirstRow,
    handleChangeAppById,
    handleMenuClick,
    dataExistList = [],
    isAllowUpdateApp,
    setEditingAppPart,
    handleUpdateWidth,
    onDragging,
    onDragStopped,
    index,
    appCopyType,
  } = props;

  const { id } = useParams();
  const { resideBarContainerRef, isResiding, itemContainerRef } = useReside({
    onUpdateWidth: (width: number) => {
      handleUpdateWidth && handleUpdateWidth(width, appPart);
    },
  });

  const { eleHoldDragRef, itemContainerDragRef, isDragging } = useDrag({
    index,
    onDragging,
    onDragStopped,
  });

  const app_part_type = appPart?.app_part_type || "";

  const isEmployeeInfoChild = useMemo(() => {
    let itemConfig = appPart?.item_config_data;
    if (typeof itemConfig === "string") {
      try {
        itemConfig = JSON.parse(itemConfig);
      } catch {
        itemConfig = undefined;
      }
    }
    return (
      !!itemConfig?.employee_info_parent_i ||
      EMPLOYEE_INFO_CHILDREN_SELECTION.some(
        (item) => item.app_part_type === app_part_type,
      )
    );
  }, [appPart, app_part_type]);

  const currentOptionsType = useMemo(() => {
    if (isEmployeeInfoChild) {
      return EMPLOYEE_INFO_CHILDREN_SELECTION.map((item) => ({
        label: item.name,
        value: item.app_part_type,
      }));
    }
    return optionsType;
  }, [isEmployeeInfoChild, optionsType]);

  const isHidden = HIDDENS_COLUMNS_SHEET.includes(app_part_type);
  const isCreate = !id;
  const debounceChangeApp = debounce(
    (appId: string, type: string, value: string, isEdit?: boolean) => {
      handleChangeAppById && handleChangeAppById(appId, type, value, isEdit);
    },
    200,
  );

  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;
  const height = BUTTON_HEIGHT[displaySize] ?? BUTTON_HEIGHT.small;
  const size = FONT_SIZE_VALUE[displaySize ?? DISPLAY_SIZES.SMALL];

  const notAllowEditApp =
    appCopyType === CopyTypeAppStore.syncConfigFromOriginal;
  const actionBtns = (
    <Fragment>
      {/* ADD_TO_LEFT or ADD_TO_RIGHT */}
      <div className="add-btn-container">
        <Tooltip title="左に列追加" placement="bottom">
          <div
            className="wrap-action"
            onClick={() =>
              handleMenuClick &&
              handleMenuClick(
                appPart,
                isFirstRow ? KEY_MENU.ADD_TO_LEFT : KEY_MENU.ADD_TO_RIGHT,
              )
            }
          >
            <Button
              className="btn-small-v chevron-right"
              label={
                <div>
                  <div>挿</div>
                  <div>入</div>
                </div>
              }
            />
          </div>
        </Tooltip>
      </div>
      {/* DUPLICATE */}
      {!isFirstRow && (
        <Fragment>
          {/*drag  */}
          <Tooltip title="移動" placement="bottom">
            <div
              ref={eleHoldDragRef}
              className={`wrap-action ${
                isAllowUpdateApp || isCreate ? "" : "disable"
              }`}
            >
              <Button
                className="btn-small-v"
                style={{ background: "#00a2e8" }}
                label={
                  <div>
                    <div>並</div>
                    <div>替</div>
                  </div>
                }
              />
            </div>
          </Tooltip>
          <Tooltip title="列複製" placement="bottom">
            <div
              className="wrap-action"
              onClick={() =>
                handleMenuClick && handleMenuClick(appPart, KEY_MENU.DUPLICATE)
              }
            >
              <Button
                className="btn-small-v"
                style={{
                  background: "#ffc000",
                }}
                label={
                  <div>
                    <div>複</div>
                    <div>製</div>
                  </div>
                }
              />
            </div>
          </Tooltip>

          {/*deleted  */}
          <Tooltip title="列削除" placement="bottom">
            {dataExistList.includes(appPart?.id?.toString() || "") ? (
              <Popconfirm
                title={WARNING_DELETE_MESSAGE}
                onConfirm={() => {
                  if (appCopyType === CopyTypeAppStore.syncConfigFromOriginal) {
                    notification.error({
                      message: "こちらは改変不可・自動更新Bizシートです",
                      duration: 3,
                    });
                  } else {
                    handleMenuClick &&
                      (isAllowUpdateApp || isCreate) &&
                      handleMenuClick(appPart, KEY_MENU.DELETE);
                  }
                }}
                okText="はい"
                cancelText="いいえ"
                okButtonProps={{ style: { order: 1 } }}
                cancelButtonProps={{
                  style: { order: 2, marginLeft: 8 },
                }}
              >
                <div
                  className={`wrap-action ${
                    isAllowUpdateApp || isCreate ? "" : "disable"
                  }`}
                >
                  <Button
                    className="btn-small-v"
                    style={{ background: "#ff0000" }}
                    label={
                      <div>
                        <div>削</div>
                        <div>除</div>
                      </div>
                    }
                  />
                </div>
              </Popconfirm>
            ) : (
              <div
                className={`wrap-action ${
                  isAllowUpdateApp || isCreate ? "" : "disable"
                }`}
                onClick={() => {
                  if (appCopyType === CopyTypeAppStore.syncConfigFromOriginal) {
                    notification.error({
                      message: "こちらは改変不可・自動更新Bizシートです",
                      duration: 3,
                    });
                  } else {
                    handleMenuClick &&
                      (isAllowUpdateApp || isCreate) &&
                      handleMenuClick(appPart, KEY_MENU.DELETE);
                  }
                }}
              >
                <Button
                  className="btn-small-v"
                  style={{ background: "#ff0000" }}
                  label={
                    <div>
                      <div>削</div>
                      <div>除</div>
                    </div>
                  }
                />
              </div>
            )}
          </Tooltip>
        </Fragment>
      )}
    </Fragment>
  );
  const firstRow = [
    { id: "fieldSettings", title: "フィールド設定" },
    { id: "columnCode", title: "列コード" },
    { id: "type", title: "タイプ" },
    { id: "detailedColumnSettings", title: "詳細列設定" },
    { id: "hideColumnName", title: "列名を表示しない" },
    { id: "required", title: "必須項目にする" },
    { id: "noDuplicate", title: "複製値を禁止" },
    { id: "showColumn", title: "列を表示" },
    { id: "defaultValue", title: "初期値" },
    { id: "actions", title: "操作" },
  ];

  if (isFirstRow) {
    return (
      <Styles
        style={{
          width: DEFAULT_WIDTH_COL,
        }}
        text_scale={displaySize}
      >
        {firstRow.map((x, index) => (
          <div key={x.id} className={`row_item ${index === 0 ? "label" : ""}`}>
            {x.title} {x.id === "actions" && actionBtns}
          </div>
        ))}
      </Styles>
    );
  }

  const appId = (appPart?.id || appPart?.uuid) + "";
  const width = appPart?.width || DEFAULT_WIDTH_COL;

  return (
    <Styles
      className={`${isResiding ? "residing" : ""} ${
        isDragging ? "dragging" : ""
      } ${isHidden ? "hidden" : ""} item_container`}
      ref={itemContainerDragRef}
      style={{
        zIndex: 5000 - index,
      }}
      text_scale={displaySize}
    >
      <div
        style={{
          width,
        }}
        ref={itemContainerRef}
      >
        <div className="row_item label">
          <div className="reside_bar-container" ref={resideBarContainerRef}>
            <div className="reside_bar" />
          </div>

          <InputEdit
            handleChange={debounceChangeApp}
            name={"name"}
            defaultValue={appPart?.name}
            appId={appId}
            width={width}
          />
        </div>
        <div className="row_item">
          <InputEdit
            handleChange={debounceChangeApp}
            name={"field_code"}
            defaultValue={appPart?.field_code}
            appId={appId}
            width={width}
          />
        </div>
        <div className="row_item">
          <Select
            options={currentOptionsType}
            onChange={(val) => {
              if (handleChangeAppById) {
                handleChangeAppById(appId, "app_part_type", val);
                if (EXCEPT_DEFAULT_VALUES.includes(val)) {
                  handleChangeAppById(appId, "default_value", "");
                }
              }
            }}
            value={app_part_type}
            style={{
              width: "100%",
              maxWidth: 180,
            }}
          />
        </div>
        <div className="row_item">
          <ButtonCommon
            onClick={() => {
              setEditingAppPart && setEditingAppPart(appPart);
            }}
            name="設定を開く"
            style={{
              fontSize: size,
              height: height,
              width: "fit-content",
            }}
          />
        </div>
        <div className="row_item">
          {!EXCEPT_HIDE_NAMES.includes(app_part_type) && (
            <Checkbox
              checked={appPart?.is_hide_name}
              onChange={(e) => {
                const isChecked = e?.target?.checked;
                handleChangeAppById &&
                  handleChangeAppById(appId, "is_hide_name", isChecked);
              }}
            />
          )}
        </div>
        <div className="row_item">
          {!EXCEPT_REQUIRED_FIELDS.includes(app_part_type) && (
            <Checkbox
              checked={appPart?.is_required_field}
              onChange={(e) => {
                const isChecked = e?.target?.checked;
                handleChangeAppById &&
                  handleChangeAppById(appId, "is_required_field", isChecked);
              }}
            />
          )}
        </div>
        <div className="row_item">
          {DUPLICATE_VALUES.includes(app_part_type) && (
            <Checkbox
              checked={appPart?.is_prohibit_duplicate_values}
              onChange={(e) => {
                const isChecked = e?.target?.checked;
                handleChangeAppById &&
                  handleChangeAppById(
                    appId,
                    "is_prohibit_duplicate_values",
                    isChecked,
                  );
              }}
            />
          )}
        </div>
        <div className="row_item">
          {!EXCEPT_SHOW_COLUMNS.includes(app_part_type) && (
            <Checkbox
              checked={appPart?.is_show_column}
              onChange={(e) => {
                const isChecked = e?.target?.checked;
                handleChangeAppById &&
                  handleChangeAppById(appId, "is_show_column", isChecked);
              }}
            />
          )}
        </div>
        <div className="row_item">
          {!EXCEPT_DEFAULT_VALUES.includes(app_part_type) && (
            <Input
              defaultValue={appPart?.default_value}
              onChange={(e) => {
                const value = e.target.value;
                debounceChangeApp(appId, "default_value", value);
              }}
            />
          )}
        </div>
        <div className="row_item">{actionBtns}</div>
      </div>
    </Styles>
  );
};

export default Item;
